import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useCreateKeywordMutation = () => {
  const fetchWithAuth = useFetchWithAuth()

  return useMutation({
    mutationFn: async (data: { keyword: string }) => {
      console.log(
        '[Keywords] useCreateKeywordMutation - sending request:',
        data
      )
      const res = await fetchWithAuth(`${URL}/keyword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      console.log(
        '[Keywords] useCreateKeywordMutation - received response:',
        res
      )
      return res as { id: string; keyword: string }
    },
    onError: (error) => {
      console.error('Could not create keyword.')
      toast.error(error.message)
    },
  })
}
